// extracted by mini-css-extract-plugin
module.exports = {"form":"src-ChangePasswordPage-___ChangePasswordPage-module__form___2JKnO","pageTitle":"src-ChangePasswordPage-___ChangePasswordPage-module__pageTitle___1qYzS"};